<template>
  <div class="info-slot-container py-1 op-sec-list-slot" ref="opSecListSlot">
    <Transition name="slide-left-right">
      <div class="" v-if="!isOpenFormPreview && !showEvaluationForm">
        <div class="ml-1 d-flex">
          <div class="d-flex">
            <h5 class="mb-0">{{ $t('operational_security.title')}}</h5> 
          </div>
          <feather-icon @click="showFiltersToggle" icon="FilterIcon" size="16" class="ml-1 cursor-pointer"/>
        </div>
        <div class="significant-event-list-filters mt-1 ml-1">
          <div v-if="showFilters">
            <h6 class="ml-1">{{ $tc("actions.filter", 0) }}</h6> 
            <div class="custom-dates-filter d-flex mb-1">
              <div class="from ml-1">
                {{ $t("action_plan.list.filters.start_date") }}
                <flat-pickr
                  id="fromDateSignificantEvent"
                  v-model="fromDate"
                  :config="datePickerConfig"
                  :disabled="!!currentDateWillcard"
                  class="timeNoBackground"
                  @input="updateFiltersInSlotData"
                />
              </div>
              <div class="ml-1">
                {{ $t("action_plan.list.filters.end_date") }}
                <flat-pickr
                  id="toDateSignificantEvent"
                  v-model="toDate"
                  :config="datePickerConfig"
                  :disabled="!!currentDateWillcard"
                  class="timeNoBackground"
                  @input="updateFiltersInSlotData"
                />
              </div>
              <span v-if="fromDate || toDate" class="d-flex align-items-center">
                <feather-icon @click="clearDatesRanges" icon="XCircleIcon" size="16" class="ml-1 cursor-pointer"/>
              </span>
            </div>
    
            <div class="d-flex gap-1">
              <div
                v-for="(dateType, index) in dateWillcardsOptions"
                :key="dateType"
                class="ml-1"
              >
                <b-form-checkbox
                  :name="`option-filter-date-${index}`"
                  :checked="currentDateWillcard === dateType"
                  :disabled="
                    (currentDateWillcard && currentDateWillcard !== dateType) ||
                    !!fromDate ||
                    !!toDate"
                  @change="handleDateWillcardChange(dateType, $event)"
                >
                  {{ $t(`operational_security.${dateType}`) }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mr-1 mb-2">
          <div class="d-flex flex-wrap">
            <v-select
              style="width: 250px;"
              v-model="horizontalFormSelected"
              :options="horizontalFormsOptions"
              :clearable="false"
              class="white-bg mx-1 mt-1"
              label="name"
              @search="onSearch"
              @input="onChangeSelectForm"
            />
            <div class="mt-1">
              <button @click="openCreateModalRegistration"
                      v-if="$can('create', 'OpSecurityFormAnswers')"
                      class="btn btn-sm btn-primary mr-1">
                {{ $t('operational_security.create_registration') }}
              </button>
              <button
                :disabled="!isFormLoaded"
                v-if="$can('create', 'OpSecurityFormAnswers') && !showHorizontalForm"
                @click="showHorizontalFormFn(true)"
                class="btn btn-sm btn-primary mr-1">
                {{ $t('operational_security.show_horizontal_form') }}
              </button>
              <button
                v-if="$can('create', 'OpSecurityFormAnswers') && showHorizontalForm"
                @click="showHorizontalFormFn(false)"
                class="btn btn-sm btn-primary">
                {{ $t('operational_security.close_horizontal_form') }}
              </button>
            </div>
          </div>
        </div>
        <div class="mb-1 mx-1">
          <b-form-input
            v-model="search"
            class="d-inline-block mr-1"
            :placeholder="$t('operational_security.prefill.search') + '...'"
          />
        </div>
        <div class="mb-1 ml-1">
          <label class="text-capitalize">{{ $t("table.show") }} </label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
          <label class="text-capitalize">{{ $t("table.entries") }} </label>
        </div>
        <div class="ml-1">
          <small>{{ $t('operational_security.prefill.table_tooltip') }}</small>
        </div>
        <div v-if="$can('create', 'OpSecurityFormAnswers')">
          <HorizontalForm
            v-if="showHorizontalForm"
            :templateData="horizontalFormSelected"
            @fetchData="fetchData"
            @onClose="showHorizontalFormFn"
          />
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th scope="col" v-for="(header, index) in tableHeaders" :key="header+index">
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody v-if="!isDataLoading">
              <tr
                @click="handleClick(item)"
                @dblclick="handleDblClick(item)"
                v-for="item in userPrefills"
                :key="item.id"
                draggable="true"
                @dragstart="onDragStart(item)"
                @dragend="onDragEnd">
                <td
                  style="min-width: 300px; white-space: normal; word-break: break-word;"
                  v-for="(header, index) in tableHeaders"
                  :key="header + index">
                  <template v-if="header === 'Referencia'">
                    <p class="mb-0">
                      {{ item.ref }}
                    </p>
                    <b>{{ formatDate(item.created_at) }}</b>
                    <div class="">
                      <b-badge
                        :variant="getStatusVariant(item.status)">
                        {{ getStatusLabel(item.status) }}
                      </b-badge>
                    </div>
                  </template>

                  <template v-else-if="header === 'Creado por'">
                    <div class="cellSize">
                      <p class="mb-0">
                        {{ getUserName(item).full_name }}
                      </p>
                      <small>{{ getUserName(item).user }} </small>
                    </div>
                  </template>

                  <template v-else>
                    <div
                      class="cellSize"
                      :id="`cell-${item.id}-${index}`"
                      :ref="`cell-${item.id}-${index}`"
                    >
                      <template v-if="isArrayCell(item, header)">
                        <div v-for="(file, i) in getCell(item, header)" :key="i">
                          <a :href="file.url" target="_blank" @click.stop>
                            {{ file.name }}
                          </a>
                        </div>
                      </template>

                      <template v-else>
                        {{ getCell(item, header) }}
                      </template>
                    </div>

                    <b-popover
                      v-if="overflowingCells[`cell-${item.id}-${index}`]"
                      :target="`cell-${item.id}-${index}`"
                      triggers="hover"
                      placement="auto">
                      <div style="max-width: 400px; word-break: break-word;">
                        <template v-if="isArrayCell(item, header)">
                          <div v-for="(file, i) in getCell(item, header)" :key="i">
                            {{ file.name }}
                          </div>
                        </template>
                        <template v-else>
                          {{ getCell(item, header) }}
                        </template>
                      </div>
                    </b-popover>
                  </template>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td scope="col" v-for="(header, index) in tableHeaders" :key="header+index">
                  <SkeletonLoading :fullWidth="true"/>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            :totalList="totalList"
            :currentPage="currentPage"
            @updatePagination="updateCurrentPage"
            :perPage="perPage">
          </Pagination>
        </div>
      </div>
    </Transition>

    <Transition>
      <div class="p-1" v-if="showEvaluationForm">
        <h5 class="my-1" v-if="isCreateRegistration || createFromDobbleClick" >{{ $t('operational_security.create_registration') }}:</h5>
        <h5 class="my-1" v-if="!isCreateRegistration && !isEditByClickPreRegistration && !createFromDobbleClick && !currentSpecialForm" >{{ $t('operational_security.prefill.create') }}!</h5>
        <h5 class="my-1" v-if="isEditByClickPreRegistration">{{ $t("operational_security.evaluation.edit_evaluation") }}</h5>
        <h5 class="my-1" v-if="currentSpecialForm">
            {{ $t("operational_security.evaluation.create") }} {{ currentSpecialForm }}
          </h5>
        <EvaluationForm
          v-if="!createFromDobbleClick"
          :isCreateRegistration="isCreateRegistration"
          :isCreate="!isCreateRegistration"
          :show-back-button="true"
          :evaluationId="formEvaluationId"
          :evaluation="formEvaluation"
          :currentSpecialForms="currentSpecialForm"
          :isCreateSpecialForms="currentSpecialForm ? true : false"
          :idFormAnswerOwner="idFormAnswerOwner"
          :dataToReplace="dataToReplace"
          @go-back-to-list="goBack()"
          @openCreateNewFormType="openCreateNewFormType"
        />

        <EvaluationForm
          v-else
          location="slot"
          :show-back-button="true"
          :isPrefill="isPrefill"
          :prefillData="prefillData"
          :evaluationId="formEvaluationId"
          :evaluation="formEvaluation"
          :currentSpecialForms="currentSpecialForm"
          :isCreateSpecialForms="currentSpecialForm ? true : false"
          :idFormAnswerOwner="idFormAnswerOwner"
          :dataToReplace="dataToReplace"
          @go-back-to-list="goBack()"
          @navigate-to-form="handleNavigateToForm($event)"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
import OperationalSecurityTemplates
  from "@/views/operational_security/templates/Index.vue";
import {SLOT_TYPES} from "@/config/layoutConfig";
import layoutMixin from "@/mixins/layoutMixin";
import axios from "@axios";
import EvaluationForm from '@/components/operationalSecurity/EvaluationForm.vue';
import store from "@/store";
import { debounce } from "lodash";
import { EventBus } from "@/libs/event-bus";
import HorizontalForm from "@/views/components/GridView/components/horizontalForms/HorizontalForm.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Pagination from "@/components/Pagination.vue";
import { getUserData } from "@/auth/utils";
import { encryptData } from "@/utils/encryptUserDataUtils";

export default {
  name: "OperationalSecurityListSlot",
  mixins: [layoutMixin],
  components: {
    OperationalSecurityTemplates,
    EvaluationForm,
    HorizontalForm,
    SkeletonLoading,
    vSelect,
    flatPickr,
    Pagination
  },
  props: {
    data: {
      type: Object,
    },
    slotId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      userPrefills: [],
      userPrefillOrdered: [],
      search: "",
      debouncedSearch: "",
      formSelected: null,
      isCreateRegistration: false,
      showEvaluationForm: false,
      isLoadingAnswers: false,
      isOpenFormPreview: false,
      answers: false,
      formattedResponses: {}, // Cache,
      showHorizontalForm: false,
      tableHeaders: ["Referencia", "Creado por"],
      isFormLoaded: false,
      formEvaluationId: null,
      isEditByClickPreRegistration: false,
      horizontalFormsOptions: [],
      horizontalFormSelected: null,
      formIsAlreadyLoaded: false,
      createFromDobbleClick: false,
      clickTimeout: null,
      isPrefill: false,
      prefillData: null,
      formEvaluation: null,
      currentSpecialForm: null,
      idFormAnswerOwner: null,
      overflowingCells: {},
      dataToReplace: null,
      showFilters: false,
      fromDate: '',
      toDate: '',
      datePickerConfig: {
        dateFormat: "Y-m-d H:i:S",
        enableTime: true,
        time_24hr: true,
        allowInput: true,
        locale: {
          firstDayOfWeek: 1,
        }
      },
      currentDateWillcard: null,
      dateWillcardsOptions: ['last24h', 'last48h', 'lastWeek', 'lastMonth'],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      totalList: 0,
      currentPage: 1,
      isDataLoading: true,
    };
  },
  mounted() {
    this.setLocalFilters();
    this.getPrefillTemplate();
    // window.Echo.private(`opsf`)
    // .listen('.opsf:updated', async () => reloadListAndForms());
    this.debouncedUpdate = debounce(value => {
      this.debouncedSearch = value;
    }, 500);
    EventBus.on(`operational_security_reload_forms_and_list`, (params) => {
      this.fetchData()
    });
    this.checkAllOverflow()
  },
  updated() {
    this.checkAllOverflow()
  },
  beforeDestroy() {
    EventBus.off(`operational_security_reload_forms_and_list`);
  },
  computed: {
    isDark() {
      return store.state.appConfig.layout.skin === "dark"
    },
    isCloseOperatinalSecurityFormModal() {
      return store.getters["grid/isCloseOperatinalSecurityFormModal"]
    },
    showBackButton() {
      const hasHistory = this.$store.getters["operational_security/hasNavigationHistory"](this.slotId);
      return hasHistory;
    },
  },
  watch: {
    currentPage: 'fetchData',
    perPage: 'fetchData',
    fromDate: 'fetchData',
    toDate: 'fetchData',
    currentDateWillcard: 'fetchData',
    isCloseOperatinalSecurityFormModal() {
      this.fetchData();
      this.goBack();
      this.goToTop();
    },
    search(value) {
      this.onSearchList(value);
    }
  },
  methods: {
    updateCurrentPage(data) {
      if(this.isDataLoading) return;
      this.currentPage = data;
    },
    handleDateWillcardChange(dateType, checked) {
      this.currentDateWillcard = checked ? dateType : null;
      this.updateFiltersInSlotData();
    },
    clearDatesRanges() {
      this.fromDate = '';
      this.toDate = '';
      this.currentDateWillcard = null;
    },
    showFiltersToggle() {
      this.showFilters = !this.showFilters;
    },
    openCreateNewFormType(form, type) {
      this.goBack();
      setTimeout(() => {
        this.currentSpecialForm = type.name;
        this.idFormAnswerOwner = form.id;
        this.dataToReplace = form?.externalFields;
        this.showEvaluationForm = true;
      }, 150);
    },
    checkAllOverflow() {
      this.$nextTick(() => {
        this.userPrefills.forEach(item => {
          this.tableHeaders.forEach((header, index) => {
            const id = `cell-${item.id}-${index}`
            const el = this.$refs[id]

            const element = Array.isArray(el) ? el[0] : el
            if (!element) return

            const isOverflowing =
              element.scrollHeight > element.clientHeight

            this.$set(this.overflowingCells, id, isOverflowing)
          })
        })
      })
    },

    getCell(item, header) {
      return this.getCellValue(item.data, header)
    },

    isArrayCell(item, header) {
      return Array.isArray(this.getCell(item, header))
    },
    getUserName(item){
      const soeIdAnalista = item?.data?.['SOEID Analista'] ?? '';
      const [user, fullname] = soeIdAnalista.split('|');
      return {
        full_name: fullname,
        user
      }
    },
    getStatusLabel(status){
      return this.$t(`operational_security.evaluation.status.${status ?? 'in_progress'}`);
    },
    getStatusVariant(status){
      if (!status) return "secondary";
      const statusVariants = {
        in_progress: "primary",
        pending: "warning",
        review: "info",
        completed: "success",
        rejected: "danger",
        reopened: "primary",
      };
      return statusVariants[status] || "secondary";
    },
    async handleNavigateToForm(formId) {
      try {
        if (this.formEvaluationId) {
          await this.$store.dispatch("operational_security/navigateToForm", {
            slotId: this.slotId,
            formData: {
              id: this.formEvaluationId,
              data: this.formEvaluation
            }
          });
        }

        const response = await axios.get(
          `/v1/operational-security-forms/template-answers/${formId}?withData=true`
        );
        const formData = response.data;

        this.formEvaluationId = formData.id;
        this.formEvaluation = formData;

        await this.$nextTick();
      } catch (error) {
        console.error("Error navigating to form:", error);
      }
    },
    async goBackToList() {
      const hasHistory = this.$store.getters["operational_security/hasNavigationHistory"](
        this.slotId
      );

      if (hasHistory) {
        const previousForm = await this.$store.dispatch(
          "operational_security/navigateBack",
          this.slotId
        );

        if (previousForm) {
          try {
            const response = await axios.get(
              `/v1/operational-security-forms/template-answers/${previousForm.id}`
            );
            const formData = response.data;

            this.formEvaluationId = formData.id;
            this.formEvaluation = formData;

            await this.$nextTick();
          } catch (error) {
            console.error("Error navigating to previous form:", error);
          }
        }
      } else {
        this.goBack()
      }
    },
    handleClick(item) {
      this.clickTimeout = setTimeout(() => {
        this.openFormOnClick(item)
      }, 250)
    },
    handleDblClick(item) {
      clearTimeout(this.clickTimeout)
      this.clickTimeout = null
      this.openFormOnDblClick(item)
    },
    onChangeSelectForm() {
      this.fetchData()
      this.showHorizontalForm = false
      this.tableHeaders = ["Referencia", "Creado por"]
      this.tableHeaders.push(...this.getUniqueBaseFields(this.horizontalFormSelected?.data))
    },
    onSearch: debounce(function (search) {
      this.getHorizontalTemplates(search)
    }, 800),
    onSearchList: debounce(function () {
      this.fetchData()
    }, 800),
    getHorizontalTemplates(q) {
      const params = {
        q,
        max: 10,
        is_horizontal: true,
        withData: true
      };

      axios
      .get('/v1/operational-security-forms/templates', { params })
      .then(response => {
        const { data } = response.data;
        this.horizontalFormsOptions = data
        if(!this.isFormLoaded) {
          this.isFormLoaded = true;
          this.horizontalFormSelected = data[0] || {}
          this.onChangeSelectForm()
        }
      })
    },
    openFormOnDblClick(item) {
      const user = store.getters["user/getUser"];
      const isOwnerOfForm = item?.owner?.id === user.id;
      if(!this.horizontalFormSelected?.prefill_template && this.horizontalFormSelected?.name !== "PRE REGISTRO" || !isOwnerOfForm || !item?.data?.['Tipo de evento']) return;
      this.isPrefill = item.is_prefill;
      this.dataToReplace = {...item?.externalFields};
      const currentSpecialForms = this.getClassificationData(item).eventType;
      this.prefillData = {...item, dataToReplace: this.dataToReplace};

      this.formEvaluationId = null
      this.formEvaluation = item
      this.currentSpecialForm = currentSpecialForms;
      this.createFromDobbleClick = true;
      this.idFormAnswerOwner = item.id;
      this.showEvaluationForm = true;
    },
    openFormOnClick(item) {
      if(this.createFromDobbleClick) return;
      this.formEvaluation = item;
      this.formEvaluationId = item.id
      this.isCreateRegistration = false
      this.showEvaluationForm = true
      this.isEditByClickPreRegistration = true
    },
    showHorizontalFormFn(isOpen){
      this.showHorizontalForm = isOpen
    },
    getCellValue(data, header) {
      if (!data) return ''

      const direct = data[header]
      if (direct !== undefined) {
        return this.formatValue(direct, header)
      }

      const key = Object.keys(data).find(k => k.startsWith(header))
      if (!key) return ''

      return this.formatValue(data[key], header)
    },

    formatValue(value, header) {
      if (!value) return ''

      if (Array.isArray(value)) {

        if (value.every(v => v?.url && v?.name)) {
          return value
        }

        if (value.every(v => typeof v === "string")) {
          return value.join(", ")
        }

        const first = value[0]
        if (!first) return ''

        if (first?.[header]?.label) {
          return first[header].label
        }

        const primitive = Object.values(first).find(v => typeof v === "string")
        return primitive || ''
      }

      return value
    },
    getUniqueBaseFields(fields) {
      const seen = new Set()

      if (fields == null) return []
    
      return fields.reduce((acc, field) => {
        const baseName = field.name.split('|')[0].trim()
    
        if (!seen.has(baseName)) {
          seen.add(baseName)
          if(field.type !== 'folio') acc.push(baseName)
        }
        return acc
      }, [])
    },
    async getPrefillTemplate() {
      const params = {
        prefill_template: true,
      };

      axios
      .get('/v1/operational-security-forms/templates', {params})
      .then(async (response) => {
        if(!response?.data?.data[0]?.id) {
          this.isFormLoaded = false
          this.getHorizontalTemplates()
          return;
        }
        const { data } = await axios.get(`/v1/operational-security-forms/templates/${response?.data?.data[0]?.id}`);
        this.horizontalFormSelected = data || {}
        this.tableHeaders.push(...this.getUniqueBaseFields(data.data))
        this.isFormLoaded = this.horizontalFormSelected?.id ? true : false
        this.getHorizontalTemplates()
        this.fetchData()
      })
      .catch((e) => {
        console.log("error", e)
        // toast.error('Error');
      });
    },
    goToTop() {
      const el = this?.$refs?.opSecListSlot
      if(!el) return;
      setTimeout(() => {
        el.scrollTo({ top: 10, left: 0, })
      }, 150);
    },
    fetchData() {
      this.isDataLoading = true;
      const user = store.getters["user/getUser"];
      const queryParams = {
        userPrefills: false,
        // incompleteForms: true,
        // user: user.id,
        templates: this.horizontalFormSelected?.id || null,
        withData: true,
        q: this.search,
        max: this.perPage,
        'page[n]': this.currentPage,
      }

      if(this.fromDate) {
        queryParams['from'] = this.fromDate;
      }
      if(this.toDate) {
        queryParams['to'] = this.toDate;
      }
      if(this.currentDateWillcard) {
        queryParams[this.currentDateWillcard] = true;
      }

      const url = '/v1/operational-security-forms/template-answers';
      axios.get(url, {params: queryParams})
        .then(response => {
          const resp = response.data.data;
          this.userPrefillOrdered = resp;
          this.userPrefills = JSON.parse(JSON.stringify(resp));
          this.totalList = response?.data?.meta?.total
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },
    onDragStart(item) {
      const dataToReplace = {...item?.externalFields}
      const payload = {...item, currentSpecialForms: this.getClassificationData(item).eventType, dataToReplace}
      this.setSlotData(
        SLOT_TYPES.OPERATIONAL_SECURITY_FORM,
        `operational_security_form`,
        payload,
        null,
        this.slotId
      );
    },
    onDragEnd() {
      this.resetSlotSelection();
    },
    openCreateModalPreRegistration() {
      this.isCreateRegistration = false
      this.showEvaluationForm = true
    },
    openCreateModalRegistration() {
      this.isCreateRegistration = true
      this.showEvaluationForm = true
    },
    formatDate(dateStr) {
      return new Date(dateStr).toLocaleString('sv-SE', {
        timeZone: 'America/Mexico_City'
      }).replace('T', ' ');
    },
    getSoeid(item) {
      const key = Object.keys(item.data || {}).find(k =>
        k.toLowerCase().includes("soeid")
      );
      return key ? item.data[key] : "";
    },
    getClassificationData(item) {
      const classificationKey = 'Clasificación [Clasificación]';
      const categoryKey = 'Clasificación [Categoría]';
      const subcategoryKey = 'Clasificación [Subcategoría]';
      const eventTypeKey = 'Tipo de evento';

      return {
        classification: item?.data?.[classificationKey] || item?.externalFields?.clasificacion || '',
        category: item?.data?.[categoryKey] || item?.externalFields?.categoria || '',
        subcategory: item?.data?.[subcategoryKey] || item?.externalFields?.subcategoria || '',
        eventType: item?.data?.[eventTypeKey] || item?.externalFields?.tipo_de_evento || '',
      }
    },
    goBack() {
      this.formSelected = null
      this.isCreateRegistration = false
      this.showEvaluationForm = false
      this.isOpenFormPreview = false
      this.formEvaluationId = null
      this.isEditByClickPreRegistration = false
      this.createFromDobbleClick = false
      this.formEvaluation = null
      this.currentSpecialForm = null;
      this.idFormAnswerOwner = null;
      this.dataToReplace = null;
    },
    updateFiltersInSlotData() {
      const currentTabId = store.state.grid.activeTab;
      const view = store.getters["grid/getUserViews"].find(
        (view) => view.data.id === currentTabId
      );
      if(!view?.id) return;
      const slot = store.state.grid.tabs[currentTabId].slots.find(
        item => item.id === this.slotId
      );
      slot.data.filters = {
        currentDateWillcard: this.currentDateWillcard,
        fromDate: this.fromDate,
        toDate: this.toDate,
      }
      store.dispatch("grid/updateUserConfig");
      this.updateFiltersInViewData(view, currentTabId)
    },
    async updateFiltersInViewData(view, currentTabId) {
      const userData = getUserData();
      userData.config.grid.tabs[currentTabId] = store.state.grid.tabs[currentTabId];
      const encryptetUserData = encryptData(userData);
      localStorage.setItem("userData", encryptetUserData);
      const payload = {
        name: view.name,
        tabId: this.tabId,
        data: {
          ...store.state.grid.tabs[currentTabId],
          id: view.data.id
        }
      }
      await axios.put(`v1/user-views/${view.id}`, payload);
    },
    setLocalFilters() {
      if(this.data?.filters?.currentDateWillcard) {
        this.currentDateWillcard = this.data?.filters?.currentDateWillcard
      }
      if(this.data?.filters?.fromDate) {
        this.fromDate = this.data?.filters?.fromDate
      }
      if(this.data?.filters?.toDate) {
        this.toDate = this.data?.filters?.toDate
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.info-slot-container {
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  width: 100%;
  height: 100%;
}

.form-container {
  max-height: 540px;
  overflow: auto;
}

/*info left, history right */
.header-grid {
  max-width: 450px;
}

@media (max-width: 992px) {
  .header-grid {
    grid-template-columns: 1fr;
  }
}

.info-card {
  background: #f9fafb;
  border: 1px solid #eceff3;
  border-radius: 8px;
  padding: 10px 12px;
}

.info-row {
  display: flex;
  gap: 6px;
  margin-bottom: 4px;
}

.info-label {
  font-weight: 600;
  color: #444;
}

.info-value {
  color: #111;
}

.table-responsive {
  overflow-x: auto;
}

.slide-right-left-enter-active,
.slide-right-left-leave-active {
  transition: transform 0.2s ease;
}

.slide-right-left-enter-from {
  transform: translateX(100%);
}

.slide-right-left-enter-to {
  transform: translateX(0%);
}

.slide-right-left-leave-from {
  transform: translateX(0%);
}

.slide-right-left-leave-to {
  transform: translateX(100%);
}

.slide-left-right-enter-active,
.slide-left-right-leave-active {
  transition: transform 0.2s ease;
}

.slide-left-right-enter-from {
  transform: translateX(-100%);
}

.slide-left-right-enter-to {
  transform: translateX(0%);
}

.slide-left-right-leave-from {
  transform: translateX(0%);
}

.slide-left-right-leave-to {
  transform: translateX(-100%);
}

ul li {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}

.popover-content {
  max-width: 400px;
  max-height: 400px;
  overflow-y: auto;
  font-size: 0.8rem;
}

.popover-list {
  margin: 0;
  padding-left: 1.5rem;
  list-style-type: decimal;
  counter-reset: item;
}

.popover-item {
  margin-bottom: 1rem;
  line-height: 1.2;

  &:last-child {
    margin-bottom: 0;
  }

  .question-header {
    font-weight: 700;
    margin-bottom: 0.35rem;
    font-size: 0.9rem;
  }

  .simple-answer {
    padding-left: 1rem;
    margin-top: 0.25rem;
    font-size: 0.9rem;
  }

  .tagged-answers {
    margin: 0.5rem 0 0 0;
    padding-left: 1.5rem;
    list-style-type: none;

    .tag-item {
      margin-bottom: 0.4rem;
      position: relative;
      padding-left: 0.5rem;

      &:before {
        content: "•";
        position: absolute;
        left: -0.5rem;
        font-weight: bold;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .tag-label {
        font-weight: 600;
        margin-right: 0.35rem;
      }
    }
  }
}

// Scroll styling para el popover
.popover-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 3px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
.firstFiveQA-container {
  width: 220px;
}
.qa-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
}

.question-text {
  font-weight: 600;
  margin-right: 3px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 130px;
}

.answer-text {
  flex: 2;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.multipleSeparatorAnswer {
  list-style: none !important;
  display: block;
  border-bottom: 1px solid #ddd;
  width: 50%;
  margin: 5px 0;
}
.table-wrap-text {
  white-space: normal;
  word-break: break-word;
}
.cellSize {
  display: -webkit-box;
  -webkit-line-clamp: 6; /* adjust lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
}
.op-sec-list-slot {
  background-color: #fff;
}
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.4em;
  margin: 0;
}
.dark-layout {
  .timeNoBackground {
    background-color: var(--second-dark) !important;
    color: #fff;
  }
}
</style>
